<template>
	<div class="haq-field">
		<label v-if="label" class="haq-field__label">{{ label }}</label>
		<v-select
			class="haq-field__control"
			outlined
			dense
			:hide-details="hideDetails"
			:menu-props="menuProps"
			v-bind="$attrs"
			:value="value"
			v-on="listeners"
		>
			<template v-for="(_, name) in $scopedSlots" #[name]="slotData">
				<slot :name="name" v-bind="slotData" />
			</template>
		</v-select>
	</div>
</template>

<script>
/**
 * Standard outlined select with an external label (no floating Vuetify label).
 */
export default {
	name: 'HaqSelect',
	inheritAttrs: false,
	props: {
		/** v-model value */
		value: {
			type: [String, Number, Array, Object],
			default: null,
		},
		/** External label shown above the field */
		label: {
			type: String,
			default: '',
		},
		/** Vuetify hide-details; use false or 'auto' when showing validation */
		hideDetails: {
			type: [Boolean, String],
			default: 'auto',
		},
		/** Menu positioning props for v-select */
		menuProps: {
			type: Object,
			default: () => ({
				bottom: true,
				offsetY: true,
				closeOnClick: true,
				closeOnContentClick: true,
				auto: true,
			}),
		},
	},
	computed: {
		/**
		 * Forward listeners and map input for v-model.
		 * @returns {Object}
		 */
		listeners() {
			return {
				...this.$listeners,
				input: (val) => this.$emit('input', val),
			};
		},
	},
};
</script>
